import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';

const locale = 'fr-FR';
const timeFormat = [locale, { hour: '2-digit', minute: '2-digit', second: '2-digit' }];
const period = 1000;

function ClockText(props) {
  const { className } = props;

  const [time, setTime] = useState(new Date().toLocaleTimeString(...timeFormat));

  useEffect(
    () => {
      const interval = setInterval(
        () => setTime(new Date().toLocaleTimeString(...timeFormat)),
        period,
      );
      return () => {
        clearInterval(interval);
      };
    },
    [],
  );

  // const tempTime = new Date();
  // const color = tempTime.getSeconds() + (60 * tempTime.getMinutes());
  if (className) {
    return (
      <div className={className}>
        {time}
      </div>
    );
  }

  return (
    <div className="clockText">
      <span className="text-sm text-current">
        {time}
      </span>
    </div>
  );
}

ClockText.propTypes = {
  className: PropTypes.string,
};

export default ClockText;
